import 'node_modules/lightslider/dist/js/lightslider.min.js';
import 'node_modules/lightgallery/dist/js/lightgallery.min.js';

import 'node_modules/lg-thumbnail/src/lg-thumbnail.js';
import 'node_modules/lg-fullscreen/src/lg-fullscreen.js';
import 'node_modules/justifiedGallery/dist/js/jquery.justifiedGallery.min.js';


$(document).ready(function() {
    
    $('[data-toggle="gallery-grid"]').each( function() {
        let $th = $(this);
        $th.justifiedGallery({
            border: 6
        }).on('jg.complete', function() {
            $th.lightGallery({
                thumbnail: true
            });
        });
    })
    
    $('[data-toggle="gallery"]').each(function() {
        var $th = $(this);
        $th.lightSlider({
            gallery: true,
            adaptiveHeight: false,
            item: 1,
            loop: true,
            thumbItem: 8,
            thumbMargin: 8,
            slideMargin: 0,
            enableDrag: false,
            currentPagerPosition: "left",
            onSliderLoad: function($el) {
                $el.lightGallery({
                    selector: $(".lslide", $th)
                });
                $th.parents(".gallery").removeClass("loading loading--processing");
            }
        })
    });
});